import { RootTemplate } from "../../components/templates/Root"

export function Component() {
  return <RootTemplate />
}
